// Simple store


export interface IAuthenticationContext {
    isAuthenticated: boolean;
    accessToken: string;
}

const initAuthenticationContext: IAuthenticationContext = {
    accessToken: '',
    isAuthenticated: false
}
class Store {
    authenticationContext: IAuthenticationContext = initAuthenticationContext;
    statusMessage: string = 'Siste statusmelding';
}


export default Store;